export const DataSourcesProviderCas = 'cas';
// eslint-disable-next-line @sas/i18n/jsx-to-localize
export const DataSourcesProviderCompute = 'Compute';

// URIFormatDataSources is the dataSources source URI pattern
export const URIFormatDataSources = '/dataSources/providers/%s/sources/%s';

// URIFormatDataTables is the dataTables table URI pattern
export const URIFormatDataTables = '/dataTables/dataSources/%s~fs~%s~fs~%s/tables/%s';
